// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1f2AC","nameUser":"style_nameUser__1fe_B"};